export default "__VITE_ASSET__a23dc631__"